import { Component } from '@angular/core';

@Component({
  selector: 'app-bobby-calves-end-of-season',
  templateUrl: './bobby-calves-end-of-season.component.html',
  styleUrls: ['./bobby-calves-end-of-season.component.scss'],
})
export class BobbyCalvesEndOFSeasonComponent {}
